// extracted by mini-css-extract-plugin
module.exports = {"socialBtn":"ExternalLoginButtonContainer_socialBtn__FXrjs"};